import {
    anything,
    Arbitrary,
    boolean,
    record,
    string
} from 'fast-check';
import { IDatiqError } from './datiq-error.model';

export const IDatiqErrorRecordModel = {
    hasError: boolean(),
    status: string(),
    message: string(),
    data: anything(),
};

export const generateError: () => Arbitrary<IDatiqError> = () => {
    return record(IDatiqErrorRecordModel, {
        requiredKeys: ['hasError'],
    });
};
